import { Button } from "@/components/ui/button";
import { Phone, Mail } from "lucide-react";

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
              From Repairs to Smart Automation – We've Got Your Garage Covered
            </h2>
            
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-foreground mb-4">Welcome to SmartLift Garage Doors</h3>
              <p className="text-muted-foreground leading-relaxed mb-6">
                At SmartLift, we specialise in garage door repairs, servicing, and smart automation upgrades that make access to your home effortless, secure, and reliable. Whether your door has stopped working, needs a safety check, or you're ready to upgrade to the latest technology, we've got you covered.
              </p>
            </div>

            <div className="mb-8">
              <h3 className="text-xl font-semibold text-foreground mb-4">Why Choose Us?</h3>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start gap-2">
                  <span className="text-accent font-bold">•</span>
                  <span><strong className="text-foreground">Fast Response Times</strong> – We know a faulty garage door can disrupt your day, so we aim to get to you quickly.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-accent font-bold">•</span>
                  <span><strong className="text-foreground">Expert Technicians</strong> – Fully trained, experienced, and equipped to work on all major garage door brands.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-accent font-bold">•</span>
                  <span><strong className="text-foreground">Smart Automation Specialists</strong> – From remote controls to smartphone-operated systems, we bring your garage into the modern age.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-accent font-bold">•</span>
                  <span><strong className="text-foreground">Transparent Pricing</strong> – No hidden fees, no surprises – just honest, upfront quotes.</span>
                </li>
              </ul>
            </div>

            <div className="mb-8">
              <h3 className="text-xl font-semibold text-foreground mb-4">A Service You Can Trust</h3>
              <p className="text-muted-foreground leading-relaxed">
                We're not just about fixing garage doors – we're about giving you peace of mind. Our team treats your home with care, our workmanship is guaranteed, and we use only durable, reliable parts.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="gap-2" asChild>
                <a href="tel:07836393815">
                  <Phone className="w-5 h-5" />
                  07836 393815
                </a>
              </Button>
              <Button size="lg" variant="outline" className="gap-2" asChild>
                <a href="mailto:office@smartliftgaragedoors.co.uk">
                  <Mail className="w-5 h-5" />
                  Email Us
                </a>
              </Button>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://images.squarespace-cdn.com/content/v1/68974af92a7345610c4b9264/9c437886-88a2-4034-9027-c1ad84336804/myQ_app.jpg"
              alt="Smart garage door automation app on smartphone"
              className="rounded-2xl shadow-2xl w-full"
              width={628}
              height={419}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
